export const UPSELL_TYPES: {
  [key: string]: string;
} = {
  MILD_ACNE_MULTI_RX_UPSELL: 'MILD_ACNE_MULTI_RX_UPSELL',
  HYDROTRET_MULTI_RX_UPSELL: 'HYDROTRET_MULTI_RX_UPSELL',
};
